// src/utils/notifyDevs.js
import { DEV_ALERT } from '@/project/configs/configs.js'

let cachedIp = null // cache IP globale

function escapeMarkdown(text = '') {
  return text
    .toString()
    .replace(/\\/g, '\\\\')
    .replace(/_/g, '\\_')
    .replace(/\*/g, '\\*')
    .replace(/\[/g, '\\[')
    .replace(/\]/g, '\\]')
    .replace(/\(/g, '\\(')
    .replace(/\)/g, '\\)')
    .replace(/~/g, '\\~')
    .replace(/`/g, '\\`')
    .replace(/>/g, '\\>')
    .replace(/#/g, '\\#')
    .replace(/\+/g, '\\+')
    .replace(/-/g, '\\-')
    .replace(/=/g, '\\=')
    .replace(/\|/g, '\\|')
    .replace(/\{/g, '\\{')
    .replace(/\}/g, '\\}')
    .replace(/\./g, '\\.')
    .replace(/!/g, '\\!')
}

async function sendTelegramMessage(botToken, chatId, text) {
  await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      chat_id: chatId,
      text,
      parse_mode: 'MarkdownV2',
    }),
  })
}

function splitMessage(text, maxLength = 4096) {
  if (text.length <= maxLength) return [text]

  const chunks = []
  let start = 0

  while (start < text.length) {
    let end = start + maxLength
    if (end >= text.length) {
      chunks.push(text.slice(start))
      break
    }

    let sliceEnd = text.lastIndexOf('\n', end)
    if (sliceEnd <= start) sliceEnd = end

    chunks.push(text.slice(start, sliceEnd))
    start = sliceEnd
  }

  return chunks
}

async function getClientIp() {
  if (cachedIp) return cachedIp

  try {
    const ipRes = await fetch('https://api.ipify.org?format=json')
    const ipData = await ipRes.json()
    cachedIp = ipData.ip || 'Inconnue'
  } catch (err) {
    console.warn('Impossible de récupérer IP:', err)
    cachedIp = 'Inconnue'
  }

  return cachedIp
}

/**
 * Envoie une notification formatée aux développeurs
 */
async function notifyDevs(message, options = {}) {
  const botToken = options.botToken || DEV_ALERT.INFO_BOT_TOKEN
  const chatId = options.chatId || DEV_ALERT.INFO_CHAT_ID
  const clientIp = await getClientIp()

  const payload = `
📢 *Notification Dev*

*Message*:
${options?.messageAlreadyEscaped ? message : escapeMarkdown(message)}

*URL*:
${escapeMarkdown(window.location.href)}

*User\\-Agent*:
${escapeMarkdown(navigator.userAgent)}

*IP*:
${escapeMarkdown(clientIp)}
${escapeMarkdown('https://whatismyipaddress.com/ip/' + clientIp)}


*Horodatage*:
${escapeMarkdown(new Date().toISOString())}
`.trim()

  const chunks = splitMessage(payload)
  for (const chunk of chunks) {
    await sendTelegramMessage(botToken, chatId, chunk)
  }
}

export { escapeMarkdown, notifyDevs }
